import { mapActions } from "vuex";
import { GET_USER_REPORTS } from '@/store/actions.type'

export default {
    data () {
        return {
            fields: [
                { key: 'createdDate', label: 'Report Date', class: 'text-left' },
                { key: 'fileName', label: 'Report Name', class: 'text-left' },
                { key: 'reportUrl', label: 'Report', class: 'text-right' }
			],
			reports: []
        }
    },

    created () {
		this.fetchuserreports();
	},

    methods: {
		...mapActions({
			getuserreports: GET_USER_REPORTS
		}),

		async fetchuserreports () {
			var self = this;
			await this.getuserreports().then(data => {
				if(data && data.length > 0) {
					// var reports = data.filter(ele => {
					// 	return ele.isPremium == 1;
					// });
					var reports = data.filter(ele => {
						return ele.inputData != '';
					});

					self.reports = reports;
				}
			});
		}
	}
}



// WEBPACK FOOTER //
// ./src/assets/js/reports.js